import moment from 'moment'

import {IntegrationService} from '../services/IntegrationService'

export const state = {
  date: moment().format('YYYY-MM-DD'),
  integrations: [],
  connecteurs: [],
  codes: [],
  plus: [],
  services: [],
  integrationModal: false
}

export const mutations = {
  setIntegration(currentState, integration) {
    currentState.integration.integrations = integration.integrations
  },
  setPlus(currentState, plus) {
    currentState.integration.plus = plus
  },
  setIntegrationModal(currentState, value) {
    currentState.integration.integrationModal = value
  },
  setServices(currentState, services) {
    currentState.integration.services = services
  }
}

export const actions = {
  loadIntegration({commit, getters, rootState}) {
    const clientid = getters.contextClientId
    return IntegrationService.getIntegrations(rootState.context.currentContext, clientid).then(integrations => {
      const parsedIntegrations = integrations.map(integration => ({
        ...integration,
        date: moment(integration.date, 'YYYY-MM-DD').format('DD/MM/YYYY'),
        uploadedAt: moment(integration.uploadedAt, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')
      }))
      commit('setIntegration', {integrations: parsedIntegrations})
    })
  },
  getPLUs({commit}) {
    IntegrationService.getPlu().then(plus => {
      commit('setPlus', plus)
    })
  },
  setIntegrationModal({commit}, value) {
    commit('setIntegrationModal', value)
  },
  getServices({commit, getters, rootState}) {
    const clientid = getters.contextClientId
    IntegrationService.getServices(rootState.context.currentContext, clientid).then(services => {
      commit('setServices', services)
    })
  }
}
export default {state, actions, mutations}
